import apiClient from "./client";
import type { ApiResponse } from "@/types";

export interface DBConfig {
  db_type: string;
  db_host: string;
  db_port: string;
  db_user: string;
  db_password: string;
  db_name: string;
}

export interface SetupStatus {
  initialized: boolean;
  db_connected: boolean;
  admin_exists: boolean;
}

export interface CheckResult {
  success: boolean;
  message: string;
}

export interface SaveData extends DBConfig {
  jwt_secret?: string;
  admin_username: string;
  admin_password: string;
}

export interface CreateAdminData {
  username: string;
  password: string;
  confirm_password: string;
}

export async function getStatus(): Promise<ApiResponse<SetupStatus>> {
  const { data } = await apiClient.get("/setup/status");
  return data;
}

export async function checkConnection(
  config: DBConfig,
): Promise<ApiResponse<CheckResult>> {
  const { data } = await apiClient.post("/setup/check", config);
  return data;
}

export async function saveConfig(
  config: SaveData,
): Promise<ApiResponse<{ initialized: boolean }>> {
  const { data } = await apiClient.post("/setup/save", config);
  return data;
}

export async function createAdmin(
  data: CreateAdminData,
): Promise<ApiResponse<{ initialized: boolean }>> {
  const res = await apiClient.post("/setup/create-admin", data);
  return res.data;
}
